import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Stack,
  SxProps,
  Theme,
} from "@mui/material";
import { useState } from "react";

import { unlinkUser } from "./../../../../api/pps";
import ButtonActionDelete from "./ButtonActionDelete";
import useNotify from "../../../../hooks/useNotify";
import { UserActions } from "../../../../models/Authorisation";
import { useSetUnlinkCustomerStore } from "../../../../stores/ppsStore";
import Text from "../../../atoms/Text";
import ExclamationIcon from "../../../icons/ui/ExclamationIcon";

type Props = {
  action: string;
  omneId: string;
  customStyle?: SxProps<Theme>;
  omneName: string;
};

const ActionButton = ({ action, omneId, customStyle, omneName }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const { setNotifySuccess, setNotifyError } = useNotify();
  const setUnlinkCustomer = useSetUnlinkCustomerStore();
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleOnClick = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
    setLoading(true);
    // unlink user
    unlinkUser(omneId.toString())
      .then(res => {
        if (res.data) {
          if (
            res.data &&
            res.data.message === "User account successfully unlinked"
          ) {
            setUnlinkCustomer(omneId.toString());
          }
          setNotifySuccess(res.data?.message);
        }
      })
      .finally(() => {
        setLoading(false);
        handleCloseModal();
      })
      .catch(error => {
        setNotifyError(error?.data?.message);
      });
  };

  if (action === UserActions.Delete) {
    return (
      <ButtonActionDelete
        omneId={omneId}
        omneName={omneName}
        customStyle={customStyle}
      />
    );
  }

  return (
    <>
      <Button
        variant="secondary"
        size="small"
        disabled={loading}
        startIcon={loading && <CircularProgress size={20} />}
        onClick={handleOpenModal}
        sx={customStyle}
        data-testid="action-button"
      >
        Unlink Insurance
      </Button>
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        data-testid="modal-component"
      >
        <Box
          width={532}
          bgcolor="mono.white"
          borderRadius={2.5}
          pb={3}
          overflow="hidden"
        >
          <Box px={2.5} py={2} bgcolor="mono.light.grey">
            <Text variant={"title_medium"}>Unlink Item</Text>
          </Box>

          <Stack p={3} alignItems="center">
            <ExclamationIcon width={48} height={48} />

            <Stack mt={2} mb={4} alignItems="center">
              <Text variant={"body_large"}>
                Are you sure you want to unlink this Omne account from
                Insurance?
              </Text>
              <Text variant={"title_small"}>{omneId}</Text>
              {omneName && <Text variant={"title_small"}>{omneName}</Text>}
            </Stack>

            <Stack direction="row" spacing={1} width={256}>
              <Button
                variant="secondary"
                size="small"
                fullWidth={true}
                onClick={handleCloseModal}
                data-testid="close-modal-button"
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                size="small"
                fullWidth={true}
                disabled={loading}
                startIcon={loading && <CircularProgress size={20} />}
                onClick={handleOnClick}
                data-testid="delete-button"
              >
                Unlink
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default ActionButton;
